import { render, staticRenderFns } from "./GroupCreate.vue?vue&type=template&id=0c7e0c90"
import script from "./GroupCreate.vue?vue&type=script&lang=ts"
export * from "./GroupCreate.vue?vue&type=script&lang=ts"
import style0 from "./GroupCreate.vue?vue&type=style&index=0&id=0c7e0c90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports